"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/**
 * State for tracking loading state of an action, including the error message on failure.
 *
 * Example:
 *
 *     loadingState = new LoadingState();
 *
 *     load() {
 *       this.loadingState.started();
 *       try {
 *         await someAsyncFunction();
 *         this.loadingState.succeeded();
 *       } catch (error) {
 *         this.loadingState.failed(error.message);
 *       }
 *     }
 *
 *     render() {
 *       if (this.loadingState.isLoading) {
 *         return "Loading...";
 *       }
 *       if (this.loadingState.errorMessage) {
 *         return this.loadingState.errorMessage;
 *       }
 *       <div>Loaded content here</div>
 *     }
 */
var LoadingState = (_class = /*#__PURE__*/function () {
  function LoadingState() {
    _classCallCheck(this, LoadingState);
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "errorMessage", _descriptor2, this);
  }
  return _createClass(LoadingState, [{
    key: "isSuccess",
    get: function get() {
      return !this.isLoading && !this.errorMessage;
    }
  }, {
    key: "started",
    value: function started() {
      this.isLoading = true;
      this.errorMessage = null;
    }
  }, {
    key: "succeeded",
    value: function succeeded() {
      this.isLoading = false;
      this.errorMessage = null;
    }
  }, {
    key: "failed",
    value: function failed(message) {
      this.isLoading = false;
      this.errorMessage = message;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.isLoading = false;
      this.errorMessage = null;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "started", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "started"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "succeeded", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "succeeded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "failed", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "failed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clear", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clear"), _class.prototype), _class);
var _default = exports["default"] = LoadingState;